/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/design-desk.jpeg";

const imageAltText = "desktop with books and laptop";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "Predictive Models for Decision Making",
    description:
      "Development of advanced predictive models applied to various sectors, enhancing decision-making accuracy through the use of machine learning techniques and data analysis.",
    url: "",
  },
  {
    title: "Interactive Data Visualization",
    description:
      "Creation of interactive dashboards for real-time data visualization, enabling efficient and personalized exploration and understanding of large volumes of information.",
    url: "",
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h2 style={{ textAlign: "center" }}>Portfolio</h2>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap", // Permite que los elementos se ajusten en pantallas más pequeñas
          padding: "2rem",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ maxWidth: "40%", alignSelf: "center", flex: "1 1 40%" }}
          className="portfolio-image"
        >
          <img
            src={image}
            style={{ height: "90%", width: "100%", objectFit: "cover", borderRadius: "10px" }}
            alt={imageAltText}
          />
        </div>
        <div className="container" style={{ flex: "1 1 55%" }}>
          {projectList.map((project) => (
            <div
              className="box"
              key={project.title}
              style={{
                padding: "1rem",
                border: "1px solid #ddd",
                borderRadius: "10px",
                marginLeft: "1rem",
              }}
            >
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3>{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
